import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * A consistent error message component
 */
export function ErrorAlert({ message, className = "" }) {
  if (!message) return null;
  
  // Handle Error objects by extracting the message
  const errorMessage = message instanceof Error ? message.message : message;
  
  return (
    <div className={`alert alert-error ${className}`}>
      <AlertCircle className="w-4 h-4" />
      <span>{errorMessage}</span>
    </div>
  );
}
